import React from 'react';
import { Box, Typography } from '@mui/material';
import { interpolate, useTranslation } from '../../i18n';
import { colors } from '../../theme/tokens';
import { usePageTitle } from '../../hooks';

/**
 * 404 / marca indisponível.
 *
 * Substitui as duas telas do legado que tinham o mesmo conteúdo:
 * `service_unavailable.blade.php` (marca com Recarga Fácil desligado ou
 * inexistente) e a rota não encontrada.
 */
export function NotFound() {
  usePageTitle('notFound.pageTitle');
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box sx={{ maxWidth: 512, width: '100%', textAlign: 'center' }}>
          <Typography
            component="h1"
            sx={{
              fontSize: '8rem',
              lineHeight: 1,
              fontWeight: 900,
              color: '#E5E7EB',
              letterSpacing: '-0.05em',
              userSelect: 'none',
            }}
          >
            {t.notFound.code}
          </Typography>

          <Box sx={{ mt: -2, position: 'relative', zIndex: 1 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: '1.875rem', md: '2.25rem' },
                fontWeight: 800,
                color: colors.textPrimary,
                letterSpacing: '-0.025em',
              }}
            >
              {t.notFound.title}
            </Typography>
            <Typography sx={{ mt: 2, fontSize: '1.125rem', color: colors.textSecondary }}>
              {t.notFound.body}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        component="footer"
        sx={{
          width: '100%',
          py: 3,
          backgroundColor: colors.surface,
          borderTop: `1px solid ${colors.border}`,
        }}
      >
        <Typography sx={{ fontSize: '0.75rem', color: colors.textMuted, textAlign: 'center' }}>
          {interpolate(t.notFound.copyright, { year })}
        </Typography>
      </Box>
    </Box>
  );
}
